// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filled{
  background: #68AD3F;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  padding: 8px 11px;
  border:2px solid #68AD3F
}

.orangeFilled{
  background: #FBB040;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  padding: 8px 11px;
border: 2px solid #FBB040;
}

.filled:hover{
background: #FBB040;
border: 2px solid #FBB040;

}
.text-btn{
font-weight: 500;
font-size: 16px;
color: #68AD3F;
border:none;
background-color: transparent;
cursor:pointer;
}

.text-btn-disabled{
  font-weight: 500;
font-size: 16px;
color: #68AD3F;
border:none;
background-color: transparent;
  opacity:0.3;
  pointer-events: none;
}

.outlined{
padding:8px 11px;
font-weight: 500;
background: transparent;
font-size: 16px;
color: #68AD3F;
border: 2px solid #68AD3F;
border-radius: 4px;
box-shadow: none;
}

.outlined:hover{
border: 2px solid #FBB040;
background: #FBB040;
color: #FFFFFF;
}

.disabledOutlined{
padding:8px 11px;
font-weight: 500;
background: transparent;
font-size: 16px;
color: #68AD3F;
border: 2px solid #68AD3F;
border-radius: 4px;
opacity:0.3;
pointer-events: none;
}

.disabled{
  opacity:0.3;
  pointer-events:none;
  background: #68AD3F;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  padding: 8px 11px;
  outline: none;
  border: 2px solid #68AD3F;
  border-radius: 4px;
pointer-events: none;
}

.orangeFilledDisabled{
  opacity:0.3;
  background: #FBB040;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  padding: 8px 11px;
border: 2px solid #FBB040;
pointer-events: none;
}

@media only screen and (min-width: 0px) and (max-width: 480px) {
.filled,.outlined,.disabled,.disabledOutlined{
  font-size: 14px;
  padding: 4px 6px;
}

}
@media only screen and (min-width: 768px) and (max-width: 981px) {
.text-btn-tab{
font-size: 14px;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB,yBAAyB;AACzB;;AAEA;AACA,mBAAmB;AACnB,yBAAyB;;AAEzB;AACA;AACA,gBAAgB;AAChB,eAAe;AACf,cAAc;AACd,WAAW;AACX,6BAA6B;AAC7B,cAAc;AACd;;AAEA;EACE,gBAAgB;AAClB,eAAe;AACf,cAAc;AACd,WAAW;AACX,6BAA6B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA;AACA,gBAAgB;AAChB,gBAAgB;AAChB,uBAAuB;AACvB,eAAe;AACf,cAAc;AACd,yBAAyB;AACzB,kBAAkB;AAClB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,mBAAmB;AACnB,cAAc;AACd;;AAEA;AACA,gBAAgB;AAChB,gBAAgB;AAChB,uBAAuB;AACvB,eAAe;AACf,cAAc;AACd,yBAAyB;AACzB,kBAAkB;AAClB,WAAW;AACX,oBAAoB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB,oBAAoB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB,yBAAyB;AACzB,oBAAoB;AACpB;;AAEA;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;AACA;AACA;AACA,eAAe;AACf;AACA","sourcesContent":[".filled{\n  background: #68AD3F;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #FFFFFF;\n  padding: 8px 11px;\n  border:2px solid #68AD3F\n}\n\n.orangeFilled{\n  background: #FBB040;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #FFFFFF;\n  padding: 8px 11px;\nborder: 2px solid #FBB040;\n}\n\n.filled:hover{\nbackground: #FBB040;\nborder: 2px solid #FBB040;\n\n}\n.text-btn{\nfont-weight: 500;\nfont-size: 16px;\ncolor: #68AD3F;\nborder:none;\nbackground-color: transparent;\ncursor:pointer;\n}\n\n.text-btn-disabled{\n  font-weight: 500;\nfont-size: 16px;\ncolor: #68AD3F;\nborder:none;\nbackground-color: transparent;\n  opacity:0.3;\n  pointer-events: none;\n}\n\n.outlined{\npadding:8px 11px;\nfont-weight: 500;\nbackground: transparent;\nfont-size: 16px;\ncolor: #68AD3F;\nborder: 2px solid #68AD3F;\nborder-radius: 4px;\nbox-shadow: none;\n}\n\n.outlined:hover{\nborder: 2px solid #FBB040;\nbackground: #FBB040;\ncolor: #FFFFFF;\n}\n\n.disabledOutlined{\npadding:8px 11px;\nfont-weight: 500;\nbackground: transparent;\nfont-size: 16px;\ncolor: #68AD3F;\nborder: 2px solid #68AD3F;\nborder-radius: 4px;\nopacity:0.3;\npointer-events: none;\n}\n\n.disabled{\n  opacity:0.3;\n  pointer-events:none;\n  background: #68AD3F;\n  font-weight: 500;\n  font-size: 16px;\n  color: #FFFFFF;\n  padding: 8px 11px;\n  outline: none;\n  border: 2px solid #68AD3F;\n  border-radius: 4px;\npointer-events: none;\n}\n\n.orangeFilledDisabled{\n  opacity:0.3;\n  background: #FBB040;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #FFFFFF;\n  padding: 8px 11px;\nborder: 2px solid #FBB040;\npointer-events: none;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n.filled,.outlined,.disabled,.disabledOutlined{\n  font-size: 14px;\n  padding: 4px 6px;\n}\n\n}\n@media only screen and (min-width: 768px) and (max-width: 981px) {\n.text-btn-tab{\nfont-size: 14px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
